export default __webpack_public_path__ + "static/media/404.cfbe44fe.jpg";